export function isDynamicImportError(error: string) {
  // TODO this is a very crude way to check for dynamic imports. Can be improved once we encounter more cases.
  return error.includes('Failed to fetch dynamically imported module')
}
